const FAQ = () => {
    return (
        <section className="App-section" id="preguntas-frecuentes">
          <h2>Preguntas Frecuentes</h2>
          <h3>¿Quién puede usar Calpecoin?</h3>
          <p>
            No queremos que la red se use con fines especulativos ni que una
            entidad externa pueda manipularla. Pero tampoco queremos tener el
            poder y la responsabilidad de gestionarla nosotros los
            desarrolladores.
          </p>
          <p>
            Calpecoin utiliza tecnología de software abierto, sin embargo la red
            de Calpecoin es para:
          </p>
          <ul>
            <li>Personas nacidas en Calpe</li>
            <li>Personas que viven o pasan parte del año en Calpe</li>
            <li>Personas que tienen familia o amigos en Calpe</li>
            <li>Personas que viven en pueblos cercanos a Calpe</li>
            <li>Empresas que operan en Calpe y pueblos cercanos</li>
          </ul>
          <p>
            Por ello, lo que haremos será no publicar{" "}
            <strong>calpecoin-core</strong> el software necesario para instalar
            un nodo completo de la red, lo que se conoce como un{" "}
            <strong>
              <em>FULL NODE</em>
            </strong>{" "}
            y permite realizar las operaciones de Proof of Work y Proof of
            Service.
          </p>
          <p>
            El software y su código fuente estarán disponible bajo demanda para
            los usuarios que caigan en una o varias de las categorias listadas
            arriba.
          </p>
          <h3>¿Cómo puedo comprar CALP?</h3>
          <p>
            <strong>No puedes.</strong> Como comentábamos, el objetivo es
            generar valor social y tecnológico para Calpe en el ámbito de
            blockchain y otras tecnologías descentralizadas. Desde el equipo de
            desarrollo de Calpecoin nunca venderemos CALP. Tampoco puedes
            comprar o vender CALP en ningún exchange.
          </p>
          <p>
            Nada te impide intercambiar dinero por Calpecoin con otros usuarios,
            no es una norma. Simplemente, el intercambio entre € y CALP no es el
            objetivo de la red ni nunca lo será. Lo que queremos fomentar es su
            uso, no su compra/venta.
          </p>
          <p>
            En este contexto además, la red debe de tomarse como un experimento.
            Nunca debe considerarse un producto financiero o un activo en el que
            invertir. La red es susceptible de sufrir <em>Hard Forks</em> si así
            lo desean los ciudadanos de Calpe que usen la red.
          </p>
          <h3>¿Cómo puedo conseguir CALP entonces?</h3>
          <p>
            Para conseguirlo hay que participar en las diversas actividades de
            la red. También puedes conseguirlo si alguien te lo envía, puedes
            utilizarlo como medio de intercambio
          </p>
          <h4>Si montas un nodo de calpecoin-core</h4>
          <ul>
            <li>
              <strong>Minando</strong>: Si tienes el software{" "}
              <strong>calpecoin-core</strong> puedes montar tu propio nodo y
              empezar a minar. Esto ayuda a proteger la red de ataques y te
              recompensa con una pequeña cantidad de CALP al resolver un bloque.
            </li>
            <li>
              <strong>Bloqueando CALP que y atengas</strong>: También puedes
              montar un <strong>masternode</strong>, bloqueando 1000 CALP. Esto
              funciona similar a un sistema Proof of Stake, por lo que recibirás
              también CALP como recompensa de bloque.
            </li>
          </ul>

          <h4>Si no quieres montar un nodo de calpecoin-core</h4>
          <ul>
            <li>
              <strong>Colaborando en un proyecto</strong>: Desde el equipo de
              desarrollo hemos reservado fondos (conseguidos por nosotros mismos
              mediante minería) para entregarlos como recompensa a quien
              construya algunos de los proyectos necesarios en el ecosistema.
              Explorers, wallets, wikis...
            </li>
            <li>
              <strong>Presentando un proyecto</strong>: Aquí no estás ganando
              Calpecoin estríctamente, ya que los fondos que se entreguen son
              para desarrollar el proyecto, pero si tienes una idea para mejorar
              el ecosistema de Calpecoin puedes presentarla y se votará si
              recibe fondos.
            </li>
            <li>
              <strong>Intercambiandolo con otros usuarios</strong>: Eres libre
              de usarlo como moneda de cambio por otros objetos, favores, etc.
            </li>
          </ul>
          
          <h3 id="construir-nodo">
            Cumplo los requisitos para montar un nodo, ¿cómo solicito
            calpecoin-core?
          </h3>
          <p>
            Debes contactarnos directamente. Verificaremos tu identidad y que
            cumples con los requisitos antes de darte acceso al software.
          </p>
          <p>Puedes hacerlo a través de:</p>
          <ul>
            <li>
              Comunicación directa - Si conoces personalmente a alguien que ya
              use el software
            </li>
            <li>
              Telegram - En el{" "}
              <a
                href="https://t.me/+H4Dj7P9F36M3ZjU0"
                target="_blank"
                rel="noreferrer"
              >
                grupo oficial de Calpecoin
              </a>
            </li>
            <li>
              Matrix -{" "}
              <a
                href="https://matrix.to/#/!mMquqKoHNjbQyDHjJd:matrix.org?via=matrix.org"
                target="_blank"
                rel="noreferrer"
              >
                En la sala oficial de Calpecoin en matrix.org
              </a>
            </li>
          </ul>
        </section>
    )
}

export default FAQ